<app-header *ngIf="showLayout" [heading]="pageHeading"></app-header>
<main [class.full-width]="!showLayout">
    <app-leftnav *ngIf="showLayout"></app-leftnav>
    <div class="main_container">
        <app-right-container></app-right-container>
    </div>
</main>
<app-footer></app-footer>